import { useState, useRef } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Loader2, Upload, Trash2 } from "lucide-react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const authHeaders = () => ({ Authorization: `Bearer ${localStorage.getItem("auth_token")}` });

export function LogoDialog({ open, onClose, pageId, logoUrl, onChanged }) {
  const [busy, setBusy] = useState(false);
  const fileRef = useRef(null);

  const upload = async (e) => {
    const file = e.target.files?.[0];
    e.target.value = "";
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const up = await axios.post(`${API}/pages/${pageId}/upload-image`, fd, { headers: authHeaders() });
      await axios.put(`${API}/pages/${pageId}/logo`, { url: up.data.url }, { headers: authHeaders() });
      toast.success("Logo gespeichert – es erscheint oben links im Header.");
      onChanged();
      onClose();
    } catch (err) {
      toast.error(err.response?.data?.detail || "Logo konnte nicht gespeichert werden");
    } finally { setBusy(false); }
  };

  const remove = async () => {
    setBusy(true);
    try {
      await axios.delete(`${API}/pages/${pageId}/logo`, { headers: authHeaders() });
      toast.success("Logo entfernt");
      onChanged();
      onClose();
    } catch { toast.error("Logo konnte nicht entfernt werden"); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="max-w-md rounded-2xl" data-testid="logo-dialog">
        <DialogHeader>
          <DialogTitle>{logoUrl ? "Logo ändern" : "Logo hinzufügen"}</DialogTitle>
          <DialogDescription>Dein Logo erscheint oben links im Header deiner Webseite. Am besten ein PNG mit transparentem Hintergrund.</DialogDescription>
        </DialogHeader>
        {logoUrl && (
          <div className="bg-slate-50 border border-slate-200 rounded-xl p-4 flex items-center justify-center h-24">
            <img src={logoUrl} alt="Aktuelles Logo" className="max-h-16 w-auto object-contain" data-testid="logo-current" />
          </div>
        )}
        <input ref={fileRef} type="file" accept="image/png,image/jpeg,image/webp" className="hidden" onChange={upload} data-testid="logo-upload-input" />
        <Button onClick={() => fileRef.current?.click()} disabled={busy} className="rounded-full bg-indigo-600 hover:bg-indigo-700" data-testid="logo-upload-btn">
          {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <><Upload className="w-4 h-4 mr-2" />Logo hochladen</>}
        </Button>
        {logoUrl && <Button variant="ghost" onClick={remove} disabled={busy} className="text-red-600" data-testid="logo-remove-btn"><Trash2 className="w-4 h-4 mr-2" />Logo entfernen</Button>}
        <p className="text-xs text-slate-500">Bitte nur Logos hochladen, an denen du die Rechte besitzt (JPG, PNG oder WebP, max. 5 MB).</p>
      </DialogContent>
    </Dialog>
  );
}
